// extracted by mini-css-extract-plugin
export default {"light":"styles_light__ade9R","wrapContainer":"styles_wrapContainer__PfM77"};